import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AddNewsCategory from "./AddNewsCategory";
import EditNewsCategory from "./EditNewsCategory";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

export default function NewsCategory() {
  const [categoryId, setCategoryId] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [data, setData] = useState([]);

  const fetchCategories = async () => {
    try {
      const response = await ApiRequest("GET", ApiEndpoints.newsCategory.categoryList);
      setData(response?.news_categories || []);
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to fetch media categories.");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleDelete = async (news_category_id) => {
    try {
      const response = await ApiRequest("POST", ApiEndpoints.newsCategory.categoryDelete, { news_category_id });
      response.error ? toast.error(response.message) : toast.success(response.message);
      fetchCategories();
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to delete media category.");
    }
  };

  const pagename = {
    name: "Media Management",
    user: "Admin",
    innerpage: "Media Management / Category",
  };

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" onClick={() => setShowAdd(true)}>Add +</Link>
        <DataTable
          data={data}
          tableHeader={["Date", "Name", "Status"]}
          tbody={["createdAt", "name", "status"]}
          setModalShow={setShowEdit}
          setId={setCategoryId}
          onDelete={handleDelete}
        />
      </div>
      <AddNewsCategory show={showAdd} onHide={() => { setShowAdd(false); fetchCategories(); }} />
      <EditNewsCategory show={showEdit} categoryId={categoryId} onHide={() => { setShowEdit(false); fetchCategories(); }} />
    </>
  );
}
